import { GetAssetFromAssetListProps, GetAssetFromAssetListResult } from './';

/*
1. One asset: all breakpoints for all breakpoints
2. Many assets: find the right breakpoint.
       If not found, use first asset.
       If many found, use the first asset.
*/
export function getAssetFromAssetList(
  props: GetAssetFromAssetListProps,
): GetAssetFromAssetListResult {
  const { assets, breakpoint } = props;
  const numberOfAssets = assets.length;
  if (numberOfAssets === 1 && assets[0].sizes === null) return assets[0];
  if (numberOfAssets > 0) {
    for (let s of assets) {
      if (s.sizes && s.sizes.includes(breakpoint)) return s;
    }
  }
  return null;
}
